import React from 'react';
import { XIcon } from 'lucide-react';
import { PROBLEMS } from '../data/content';
export function Problems() {
  return <section aria-labelledby="problems-title" className="w-full bg-soft px-3 py-6 sm:px-5" data-id="element-206" data-mp="36wsolx62kypr">
      <div className="mx-auto max-w-4xl text-center" data-id="element-207" data-mp="323zib4uydibk">
        <h2 id="problems-title" className="font-head text-2xl uppercase leading-[0.98] text-navy sm:text-4xl" data-id="element-208" data-mp="322oghal2ikn3">
          Does this sound familiar?
        </h2>

        <ul className="mx-auto mt-3 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-209" data-mp="2t55tw1rrzy93">
          {PROBLEMS.map(item => <li key={item} className="flex items-start gap-2 rounded-lg border border-coral/25 bg-white px-3 py-2 text-[13px] leading-snug text-navy" data-id="element-210" data-mp="2o4hxt1oowr80">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-coral" aria-hidden="true" data-id="element-211" data-mp="2f4uxkj7p5rgj" />
              {item}
            </li>)}
        </ul>

        <p className="mt-3 font-head text-lg uppercase leading-tight text-green sm:text-2xl" data-id="element-212" data-mp="hdilijtkrxb2">
          Stop searching. Start with a system.
        </p>
      </div>
    </section>;
}